<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar {{ titulo }}
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  v-model="content.nome"
                  :label="`${titulo}`"
                  dense
                  outlined
                  readonly
                ></v-text-field>
                <v-text-field
                  v-model="content.nivelDeEnsino.descricao"
                  label="Nível de Ensino"
                  dense
                  outlined
                  readonly
                ></v-text-field>
                <v-text-field
                  v-model="content.componenteCurricular.descricao"
                  label="Componente Curricular"
                  dense
                  outlined
                  readonly
                ></v-text-field>
                <v-textarea
                  v-model="content.descricao"
                  label="O que é esperado do aluno"
                  outlined
                  rows="4"
                  dense
                  readonly
                ></v-textarea>
              </v-col>
            </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            <v-icon>mdi-close</v-icon>
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { PerfilTurma } from '~/commons/classes/perfil-turma';

export default {
  props: {
    ...new DialogProps(PerfilTurma),
    titulo: {
      type: String,
      default: 'Perfil da Turma'
    }
  }
};
</script>
